/**
 * This is the template for a 'restricted page'
 *
 * All pages which require a certain role level will extend this class
 *
 * render() will check if user is logged in. if not, will display Login component
 *
 * This page will handle doLogin which will set loggedIn to true
 * This page will know how to check if the user is logged in
 *
 */
import React, { Component } from 'react';
import Cookies from 'universal-cookie';
import Login from './Login';
import Keycloak from 'keycloak-js';

import { REF_CURRENT_USER_ID, REF_KEYCLOAK_AUTH_TOKEN, REF_KEYCLOAK_REFRESH_TOKEN } from 'nexus-common/src/components/access/constants';

const cookies = new Cookies();
interface Window {
    _env_: any;
}

const keycloak = Keycloak({
    "clientId": process.env.REACT_APP_KC_CLIENT_ID || '',
    "realm": process.env.REACT_APP_KC_REALM || '',
    "url": process.env.REACT_APP_KC_URL,
});

export default abstract class PageBase extends Component<any, any> {

    protected currentUser;

    constructor(props: any) {
        super(props);

        this.state = {};

        this.isUserLoggedIn = this.isUserLoggedIn.bind(this);
        this.doLogin = this.doLogin.bind(this);
        this.logoutHandler = this.logoutHandler.bind(this);
        this.renderPage = this.renderPage.bind(this);
        this.currentUser = this.props.currentUser;

        // If the Access token is set to expire, we should replace it with a new token if able.
        keycloak.onTokenExpired = () => {
            cookies.remove(REF_KEYCLOAK_AUTH_TOKEN, {domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none'});
            keycloak.updateToken(30).then(() => {
                if(keycloak.token !==undefined){
                    cookies.set(REF_KEYCLOAK_AUTH_TOKEN, keycloak.token, {domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none'});
                }
            });
        };
    }

    /***************************
     * Restriction logic section
     **************************/

    /**
     * Returns true if and only if the user is logged in
     * @returns {boolean}
     */
    isUserLoggedIn(): boolean {
        return !!this.currentUser;
    }

    /**
     * Login handler which simply updates the Page's state
     */
    doLogin() {
        this.setState({ userLoggedIn: true });
        this.props.handleUserChange();
    }

    logoutHandler() {
        cookies.remove(REF_KEYCLOAK_AUTH_TOKEN, {domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none'})
        cookies.remove(REF_CURRENT_USER_ID, {domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none'})
        cookies.remove(REF_KEYCLOAK_REFRESH_TOKEN, {domain: process.env.REACT_APP_COOKIE_DOMAIN, secure: true, sameSite: 'none'})
        // this.props.handleUserChange();
        window.location.href = 'https://www.emsl.pnnl.gov';
    }


    /**
     * Abstract function which MUST be defined by the implementers.
     */
    abstract renderPage(): any;

    render() {
        if (this.isUserLoggedIn()) {
            return this.renderPage();
        }
        return (
            <Login {...this.props} keycloak={keycloak} loginHandler={this.doLogin} logoutHandler={this.logoutHandler} />
        );
    }
}
